<script setup lang="ts" name="SailingScheduleContentPort">
import BaseItem from '~/components/BaseItem.vue';

defineProps<{
  label: string;
  port: string | null;
  date?: string;
}>();
</script>

<template>
  <div>
    <BaseItem :label="label" fallback="-" truncate :value="port" />
    <p v-if="date">{{ date }}</p>
  </div>
</template>
